import { Component, Input, Output, EventEmitter, OnInit, AfterViewInit, OnDestroy, ElementRef, ChangeDetectorRef } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';

export interface DateRangeOutput {
  startDate: string | null;
  endDate: string | null;
  isValid: boolean;
}

export type DatePickerMode = 'date' | 'datetime-local';

@Component({
  selector: 'aph-custom-date-picker',
  templateUrl: './aph-custom-date-picker.component.html',
  styleUrls: ['./aph-custom-date-picker.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(20px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'translateX(20px)' }))
      ])
    ])
  ]
})
export class AphCustomDatePickerComponent implements OnInit, AfterViewInit, OnDestroy {
  
  @Input() labelInicio: string = 'Fecha Inicio';
  @Input() labelFin: string = 'Fecha Fin';
  @Input() maxDaysLimit: number = 180;
  @Input() mode: DatePickerMode = 'date'; 
  @Input() singleMode: boolean = false;
  @Input() minDate: any = '';
  @Input() maxDate: any = '';
  @Input() startDate: string = '';
  @Input() endDate: string = '';

  @Input() IsDisabled: boolean = false;
  @Input() IsDisabledEnd: boolean = false;
  @Output() startDateChange = new EventEmitter<string>();
  @Output() endDateChange = new EventEmitter<string>();
  @Output() onValidationStatus = new EventEmitter<boolean>();

  isInvalidRange: boolean = false;
  errorMessage: string = '';

  isCompact: boolean = false;
  private resizeObserver: ResizeObserver | null = null;

  constructor(private el: ElementRef, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void { this.validateRange(); }

// Se dispara cuando hay cambios en los @Input

  setToday() {
    const now = new Date();
    const offset = now.getTimezoneOffset() * 60000;
    const localISOTime = (new Date(now.getTime() - offset)).toISOString();
    this.startDate = this.mode === 'date' ? localISOTime.split('T')[0] : localISOTime.slice(0, 16);
    this.endDate = this.mode === 'date' ? localISOTime.split('T')[0] : localISOTime.slice(0, 16);
    this.updateValues();
  }

  resetFilters() {
    this.startDate = '';
    this.endDate = '';
    this.updateValues();
  }

  updateValues() {
    this.validateRange();
    this.startDateChange.emit(this.startDate);
    this.endDateChange.emit(this.endDate);
  }

  validateRange() {
    this.isInvalidRange = false;
    if (this.singleMode) {
      this.onValidationStatus.emit(!!this.startDate);
      return;
    }
    if (this.startDate && this.endDate) {
      const inicio = new Date(this.startDate);
      const fin = new Date(this.endDate);
      const diffDays = (fin.getTime() - inicio.getTime()) / (1000 * 3600 * 24);

      if (inicio > fin) {
        this.isInvalidRange = true;
        this.errorMessage = 'La fecha de inicio es mayor a la fecha final.';
      } else if (diffDays > this.maxDaysLimit) {
        this.isInvalidRange = true;
        this.errorMessage = `Intervalo máximo ${this.maxDaysLimit} días.`;
      }
    }
    this.onValidationStatus.emit(!this.isInvalidRange && !!this.startDate && !!this.endDate);
  }

  ngAfterViewInit() {
    // Escuchamos el tamaño del contenedor del componente
    this.resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        // Si el ancho es menor a 400px, activamos modo compacto
        this.isCompact = entry.contentRect.width < 400;
        this.cdr.detectChanges(); // Forzamos la actualización de la vista
      }
    });

    this.resizeObserver.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}